import { ActionType } from "../action-types/type";

import { AuthAction } from "../actions/index";

const userJson = localStorage.getItem("user");
const user = userJson ? JSON.parse(userJson) : null;

const initialState = user
  ? { isLoggedIn: true, user }
  : { isLoggedIn: false, user: null };

export function authReducer(state: any = initialState, action: AuthAction) {
  switch (action.type) {
    case ActionType.REGISTER_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
      };
    case ActionType.REGISTER_FAIL:
      return {
        ...state,
        isLoggedIn: false,
      };
    case ActionType.LOGIN_SUCCESS:
      const loginState = {
        ...state,
        isLoggedIn: true,
        user: {
          userName: action.payload.user.userName,
          issueDate: action.payload.user.issueDate,
          expirationDate: action.payload.user.expirationDate,
          status: action.payload.user.status,
          message: action.payload.user.message,
          path: action.payload.user.path,
          token: action.payload.user.token,
          roles: [...action.payload.user.roles],
          preferredLanguage: action.payload.user.preferredLanguage,
        },
      };
      localStorage.removeItem("user");
      localStorage.setItem("user", JSON.stringify(loginState.user));
      localStorage.setItem("language", loginState.user.preferredLanguage);
      return { ...loginState };
    case ActionType.LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case ActionType.LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case ActionType.UPDATE_USER_ROLES:
      return {
        ...state,
        user: { ...state.user, roles: [...action.payload.roles] },
      };
    default:
      return state;
  }
}
